import type { FC } from "react";
import { AppImage } from "@/src/components/NextImage";
import { cn } from "utils";
import { ONBOARDING_WIZARD_ASSETS } from "../onboardingWizardAssets";

interface OnboardingEdAvatarProps {
  className?: string;
}

/** Figma Ed hero bubble avatar — 48px white ring + 24px Ed mark (96121:8435). */
export const OnboardingEdAvatar: FC<OnboardingEdAvatarProps> = ({
  className,
}) => (
  <div
    className={cn("size-12 shrink-0", className)}
    data-node-id="96293:46184"
    data-testid="intro-ed-avatar"
  >
    <AppImage
      src={ONBOARDING_WIZARD_ASSETS.edAvatar}
      alt=""
      width={48}
      height={48}
      className="size-12 rounded-full"
      onError={(e) => {
        (e.target as HTMLImageElement).style.display = "none";
      }}
    />
  </div>
);
